module.exports = __webpack_public_path__ + "static/media/Soil.bbdfbe09.jpg";